import { connect } from 'react-redux'

import { setWaiverFormField } from 'actions/account/forms/waiverForms'

const mapStateToProps = ({ forms: { waiverForms } }) => ({
  waiverForms
})

const actions = {
  setWaiverFormField
}

const withRedux = connect(mapStateToProps, actions)

export default withRedux
